import React from 'react';
import Sidebar from 'react-sidebar';

import SidebarContent from './SidebarContent';
import './sidebar.css'

import {CloseOutlined, MenuOutlined} from "@ant-design/icons";

// import CloseOutlined from "@ant-design/icons/lib/icons/CloseOutlined";

class SidebarTabs extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showSidebar: false
        };
        this.toggleSidebar = this.toggleSidebar.bind(this);
    }

    toggleSidebar() {
        this.setState({showSidebar: !this.state.showSidebar});
    }

    render() {
      const showSidebar = this.state.showSidebar;
        return (
            <Sidebar
                sidebar={<SidebarContent onClose={this.toggleSidebar}/>}
                open={this.state.showSidebar}
                onSetOpen={this.toggleSidebar}
                rootClassName={`sidebar ${this.state.showSidebar && 'open'}`}
            >
                <div className='side-menu-icon' onClick={() => this.toggleSidebar()}>
                  {showSidebar
                  ? <CloseOutlined style={{ color: '#fff'}}/>
                  : <MenuOutlined style={{ color: '#fff'}}/>}
                </div>
            </Sidebar>
        );
    }
}

export default SidebarTabs;